export enum TypeRetorno {
  BOLETO = 'Boleto',
  DEBITO_AUTOMATICO = 'Debito Automatico',
  FAILED = 'Falhou',
  NO_CHANGE = 'Nenhuma alteração',
}

export enum StatusRetorno {
  SUCCESS = 'Sucesso',
  PENDING = 'Pendente',
  IN_PROGRESS = 'Em andamento',
  CANCELLED = 'Cancelado',
  ENTRY_CANCELLED = 'Entrada cancelada',
  FAILED = 'Falhou',
  NO_CHANGE = 'Nenhuma alteração',
}

